// @flow

import * as React from 'react';
import styles from './styles.scss';

const Preloader = () => (
  <div id="preloader">
    <div id="overlay" />
    <div id="inner">
      <div id="content">
        <div id="svgCover" />
        <svg id="svgCircle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41">
          <g id="circle">
            <path d="M18.18,20.39a14.49,14.49,0,0,0,1.3,1.14l1.12-3.4A7.91,7.91,0,0,0,18.18,20.39Z" fill="#fff" />
            <path
              d="M23.58,9.08,24.3,6.9c.23-.77.36-1.46,0-1.65s-.91-.16-2.16,1.26a7.85,7.85,0,0,0-.75,1,7.19,7.19,0,0,0-.41.7l.39.07A9.36,9.36,0,0,1,23.58,9.08Z"
              fill="#fff"
            />
            <path
              d="M20.13,0A20.12,20.12,0,1,0,40.25,20.12,20.12,20.12,0,0,0,20.13,0ZM9.39,15.09a1.21,1.21,0,0,1,.67-1.53c.53-.12,1.1.37,1.26,1.1a1.21,1.21,0,0,1-.67,1.53C10.12,16.31,9.56,15.82,9.39,15.09Zm3.46,5.13,0,0,0,.06a.8.8,0,0,1-.36.36,1.24,1.24,0,0,1-1.52-.8,1.25,1.25,0,0,1,.3-1.69c.5-.25,1.18.11,1.52.8a1.76,1.76,0,0,1,.18.77A1.28,1.28,0,0,1,12.85,20.22Zm4,13.74a2.7,2.7,0,0,1-1.07,1.49c-1,.68-2.19.76-2.67.08s0-1.85.93-2.52a2.72,2.72,0,0,1,1.78-.54l.91-2.74a5.08,5.08,0,0,0,1.3.2Zm8.56-8.22h0a12.93,12.93,0,0,1-2.52,2.43h0a7.66,7.66,0,0,1-3.83,1.56,7.07,7.07,0,0,1-2.27-.16A3.89,3.89,0,0,1,15.69,29c-2.42-1.74-1.71-4.77.12-7.3.3.28.64.58,1,.85-1.34,2.1-1.62,4.79.71,5l1.2-3.65c.24.14.73.42,1,.54l-.85,2.94a9.31,9.31,0,0,0,3.33-2.15,14,14,0,0,1-1.51-.53l-.07,0L20,24.4l-.07,0-.44-.23-.14-.07L19.22,24l-.48-.27-.1-.06-.1-.06-.59-.38c-.35-.24-.72-.52-1-.77s-.69-.59-1-.87h0q-.53-.51-1-1.06a13.56,13.56,0,0,1-1-1.4c-1.88-2.9-2.27-6.11-.7-8.41,1.35-2,3.86-2.87,6.7-2.64.08-.16.16-.32.26-.48A8,8,0,0,1,21.26,6c1.68-1.85,2.73-1.9,3.24-1.68.8.35.71,1.47.34,2.69l-.73,2.34a8.77,8.77,0,0,1,2.81,2.51,14.05,14.05,0,0,0-3.06-1.73l-.57-.21a10.7,10.7,0,0,0-2.51-.57l-.3,0h-.75l-.4,0a4.82,4.82,0,0,0-3.59,1.79c-1.05,1.41-1.07,3.38-.25,5.38a10.26,10.26,0,0,0,.65,1.3,12.26,12.26,0,0,0,1.39,1.89l.13-.13a10.46,10.46,0,0,1,3.12-2.06L21.63,15h.08l.74,0-.65,2.21a7.75,7.75,0,0,1,1.84-.36,12.48,12.48,0,0,0-1.95.72l-1.35,4.62a13.57,13.57,0,0,0,3.14,1.56,19.64,19.64,0,0,0,1.4-2.06c1.52-2.89,1.61-5.86-.1-6.6a5.19,5.19,0,0,0-1.85-.28h-.65l-.3,0h-.59l-.17,0h-.07l-.23,0h0l-.21-.07-.07,0-.16-.07-.06,0-.21-.13-.05,0-.23-.19-.07-.07L19.73,14l-.07-.1-.1-.14-.07-.11a5.14,5.14,0,0,1-.2-4.08l.46,0h.7a4.61,4.61,0,0,0-.13,1.92A2.25,2.25,0,0,0,21.2,13a2.11,2.11,0,0,0,1,.31h0l1-3.16.57.22-.87,3a6.68,6.68,0,0,1,3.69.49c2.38,1.21,2.36,4.9,1,8.3a13.54,13.54,0,0,1-.77,1.59c-.12.21-.24.42-.38.62h0l-.28.43,0,0-.31.44-.39.51Zm1.2-.07a9.66,9.66,0,0,1-1,.07l.35-.46c.24-.32.46-.65.67-1h.52a4.87,4.87,0,0,0,3.71-1.8A4.81,4.81,0,0,1,26.65,25.67Z"
              fill="#fff"
            />
          </g>
        </svg>
        <svg id="svgText" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 40.25">
          <g id="cstext">
            <path
              d="M56.15,23.44a4.51,4.51,0,0,1-1.33-3.33,4.56,4.56,0,0,1,4.64-4.63,5,5,0,0,1,3.41,1.24l-1.24,1.36a3.43,3.43,0,0,0-2.18-.74,2.72,2.72,0,0,0-2,.78,2.7,2.7,0,0,0-.76,2,2.78,2.78,0,0,0,.77,2.06,2.75,2.75,0,0,0,2,.76,3.33,3.33,0,0,0,2.16-.74l1.24,1.36a5,5,0,0,1-3.41,1.24,4.53,4.53,0,0,1-3.31-1.34"
              fill="#fff"
            />
            <polygon
              points="68.65 24.77 68.65 15.49 75.48 15.48 75.48 17.21 70.51 17.21 70.51 19.2 74.23 19.2 74.23 20.93 70.51 20.93 70.51 23.04 75.47 23.04 75.47 24.77 68.65 24.77"
              fill="#fff"
            />
            <polygon
              points="81.16 24.77 81.16 15.48 81.78 15.48 87.6 21.3 87.6 15.48 89.46 15.48 89.46 24.77 88.78 24.77 83.02 19.01 83.02 24.77 81.16 24.77"
              fill="#fff"
            />
            <polygon
              points="102.78 15.48 102.78 17.22 99.68 17.22 99.68 24.77 97.82 24.77 97.82 17.22 94.72 17.22 94.72 15.48 102.78 15.48"
              fill="#fff"
            />
            <polygon
              points="107.94 24.77 107.94 15.49 114.77 15.48 114.77 17.21 109.8 17.21 109.8 19.2 113.52 19.2 113.52 20.93 109.8 20.93 109.8 23.04 114.75 23.04 114.75 24.77 107.94 24.77"
              fill="#fff"
            />
            <path
              d="M126,20.72l2.32,4.05h-2.13L124,20.93h-1.7v3.84h-1.86V15.48h4.05q3.25,0,3.26,2.68A2.4,2.4,0,0,1,126,20.72M122.3,19.2h2.6c.75,0,1.13-.35,1.15-1s-.4-.93-1.13-1H122.3Z"
              fill="#fff"
            />
            <path
              d="M138.16,15.79a4.34,4.34,0,0,1,1.33.93L138.25,18a2.14,2.14,0,0,0-1.74-.74q-1.11,0-1.42.53a.72.72,0,0,0,0,.9,2.44,2.44,0,0,0,1.42.56,4.6,4.6,0,0,1,2.14.77,2.32,2.32,0,0,1,1,2.08,2.38,2.38,0,0,1-1,1.92,3.74,3.74,0,0,1-2.39.8A5.53,5.53,0,0,1,134,24.4a4.67,4.67,0,0,1-1.49-1l1.24-1.24a3,3,0,0,0,2.11.87q1.23,0,1.54-.53a1,1,0,0,0,0-1.05q-.31-.53-1.54-.65a5,5,0,0,1-2-.68,2.06,2.06,0,0,1-.93-1.92,2.31,2.31,0,0,1,1.06-2,3.72,3.72,0,0,1,2.17-.75,5.2,5.2,0,0,1,2,.31"
              fill="#fff"
            />
            <polygon
              points="152.66 15.48 152.66 17.22 149.57 17.22 149.57 24.77 147.71 24.77 147.71 17.22 144.61 17.22 144.61 15.48 152.66 15.48"
              fill="#fff"
            />
            <path
              d="M155.92,24.77l3.72-9.29h1.86l3.71,9.28h-2l-.56-1.42h-4.21l-.56,1.42Zm4.7-6.81-1.41,3.53H162Z"
              fill="#fff"
            />
            <path
              d="M170.52,23.44a4.5,4.5,0,0,1-1.33-3.33,4.57,4.57,0,0,1,4.64-4.63,5,5,0,0,1,3.41,1.24L176,18.08a3.43,3.43,0,0,0-2.18-.74A2.64,2.64,0,0,0,171,20.09a2.64,2.64,0,0,0,2.8,2.82,2.56,2.56,0,0,0,1.54-.4V20.93h-1.24V19.2h3.1v4.34a5,5,0,0,1-3.41,1.24,4.52,4.52,0,0,1-3.3-1.34"
              fill="#fff"
            />
            <rect x="182.92" y="15.48" width="1.85" height="9.3" fill="#fff" />
            <polygon
              points="190.44 24.77 190.44 15.48 191.06 15.48 196.88 21.3 196.88 15.48 198.74 15.48 198.74 24.77 198.06 24.77 192.3 19.01 192.3 24.77 190.44 24.77"
              fill="#fff"
            />
            <path
              d="M204.59,23.44a4.5,4.5,0,0,1-1.34-3.33,4.57,4.57,0,0,1,4.64-4.63,5,5,0,0,1,3.41,1.24l-1.24,1.36a3.41,3.41,0,0,0-2.17-.74,2.65,2.65,0,0,0-2.78,2.76,2.8,2.8,0,0,0,.78,2.06,2.74,2.74,0,0,0,2,.76,2.57,2.57,0,0,0,1.54-.4V20.93h-1.24V19.2h3.1v4.34a5,5,0,0,1-3.41,1.24,4.52,4.52,0,0,1-3.31-1.34"
              fill="#fff"
            />
            <polygon
              points="212.56 15.8 213.12 15.8 213.12 17.16 213.46 17.16 213.46 15.8 214.01 15.8 214.01 15.49 212.56 15.49 212.56 15.8"
              fill="#fff"
            />
            <polygon
              points="215.89 15.49 215.16 16.32 214.43 15.49 214.32 15.49 214.32 17.16 214.66 17.16 214.66 16.19 215.16 16.75 215.66 16.19 215.66 17.16 216 17.16 216 15.49 215.89 15.49"
              fill="#fff"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
);

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/Preloader/index.js